import { combineReducers } from "redux";
//import Catalogos from './base.reducer';
import SecondaryNavbar from './cms.reducer';

const reducer = combineReducers({
    //Catalogos,
    SecondaryNavbar
});

export default reducer;